import serviceTokenNew from '../../services/requestTokenNew';
const API_GATEWAY_URL = process.env.REACT_APP_API_GATEWAY_URL;

/**
 * @description create tickets
 */
export const createOrderMessageApi = (data) => {
  return serviceTokenNew({
    url: `${API_GATEWAY_URL}privateauthservice/ticketingservice/v1/admin/tickets`,
    method: 'post',
    data,
    isTicketApi: true
  });
};

/**
 * @description getting all messages of an order
 * @param {string} order_id
 */
export const getOrderMessageApi = (orderId) => {
  return serviceTokenNew({
    url: `${API_GATEWAY_URL}privateauthservice/ticketingservice/v1/admin/tickets/orders/${orderId}/messages`,
    method: 'get',
    isTicketApi: true
  });
};

/**
 * @description send a message
 * @param {string} order_id
 */
export const sendOrderMessageApi = (orderId, data) => {
  return serviceTokenNew({
    url: `${API_GATEWAY_URL}privateauthservice/ticketingservice/v1/admin/tickets/orders/${orderId}/messages`,
    method: 'post',
    data,
    isTicketApi: true
  });
};
